import { AbstractAnalytics } from './abstract-analytics'

import * as MarketGradeAction from './tracking-events'

class MarketGradeAnalytics extends AbstractAnalytics<MarketGradeAction.Event> { }

export const marketGradeAnalytics = new MarketGradeAnalytics()
